import { supabase } from "@/utils/supabase";
import { VehicleModelMapper } from "@/adapters/VehicleModel.mapper";
export class VehicleModelService {
    async getVehicleModelsWithParams(params) {
        try {
            let query = supabase()
                .from("vehicleModelsSearchView")
                .select("*", { count: "exact" });
            // Поиск
            if (params.filters) {
                const search = params.filters.search?.trim();
                if (search) {
                    const ors = [
                        `model.ilike.*${search}*`,
                        `manufacturerName.ilike.*${search}*`,
                    ];
                    query = query.or(ors.join(","));
                }
            }
            // Сортировка
            if (params.sorters && Object.keys(params.sorters).length > 0) {
                Object.entries(params.sorters).forEach(([field, order]) => {
                    if (order === "ascend")
                        query = query.order(field, { ascending: true });
                    else if (order === "descend")
                        query = query.order(field, { ascending: false });
                });
            }
            else {
                query = query.order("model", { ascending: true });
            }
            // Пагинация
            const from = (params.page - 1) * params.pageSize;
            query = query.range(from, from + params.pageSize - 1);
            const { data, error, count } = await query;
            if (error)
                throw error;
            return {
                data: data.map(VehicleModelMapper.toSearchData),
                total: count || 0,
                page: params.page,
                pageSize: params.pageSize,
            };
        }
        catch (error) {
            console.error("Error in getVehicleModelsWithParams:", error);
            throw error;
        }
    }
    async getVehicleModelsByIds(ids) {
        const { data, error } = await supabase()
            .from("vehicle_models")
            .select("*")
            .in("id", ids)
            .eq("is_deleted", false);
        if (error) {
            throw error;
        }
        return data.map(VehicleModelMapper.toDomain);
    }
    async createVehicleModel(vehicleModelData) {
        try {
            const vehicleModelDto = VehicleModelMapper.toCreateDto(vehicleModelData);
            const { data, error } = await supabase()
                .from("vehicle_models")
                .insert([vehicleModelDto])
                .select()
                .single();
            if (error)
                throw error;
            return VehicleModelMapper.toDomain(data);
        }
        catch (error) {
            console.error("Error creating vehicle model:", error);
            throw error;
        }
    }
    async updateVehicleModel(id, vehicleModelData) {
        try {
            const vehicleModelDto = VehicleModelMapper.toCreateDto(vehicleModelData);
            const { data, error } = await supabase()
                .from("vehicle_models")
                .update(vehicleModelDto)
                .eq("id", id)
                .select()
                .single();
            if (error)
                throw error;
            return VehicleModelMapper.toDomain(data);
        }
        catch (error) {
            console.error("Error updating vehicle model:", error);
            throw error;
        }
    }
    async deleteVehicleModel(id) {
        try {
            const { error } = await supabase()
                .from("vehicle_models")
                .update({
                is_deleted: true,
            })
                .eq("id", id);
            if (error)
                throw error;
        }
        catch (error) {
            console.error("Error deleting vehicle model:", error);
            throw error;
        }
    }
}
export const vehicleModelService = new VehicleModelService();
